module.exports = __webpack_public_path__ + "static/1144711962.53460a8c.jpg";